import classNames from 'classnames'

import { EMPTY_OBJECT } from '../../../constants/common'

import { RADIO_SIZE } from './Radio.constants'

import * as styles from './Radio.module.css'

function Radio({
  checked,
  className = styles.Radio,
  containerProps: {
    className: radioContainerClassName = styles.container,
    ...containerProps
  } = EMPTY_OBJECT,
  disabled,
  id,
  label,
  labelProps: {
    className: labelClassName = styles.label,
    ...labelProps
  } = EMPTY_OBJECT,
  name,
  size = RADIO_SIZE.medium,
  value,
  onBlur,
  onChange,
}) {
  const radioClassName = classNames(className, styles[size], {
    [styles.checked]: checked,
  })

  const containerClassName = classNames(radioContainerClassName, {
    [styles.disabled]: disabled,
  })

  return (
    <div {...containerProps} className={containerClassName}>
      <span className={radioClassName}>
        <input
          checked={checked}
          className={styles.input}
          disabled={disabled}
          id={id}
          name={name}
          type='radio'
          value={value}
          onBlur={onBlur}
          onChange={onChange}
        />
      </span>
      <label {...labelProps} className={labelClassName} htmlFor={id}>
        {label}
      </label>
    </div>
  )
}

export default Radio
